
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explain",
      function () {
        return require("private-next-pages/explain.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explain"])
      });
    }
  